export default class {

    constructor( callback, time, scope = false ) {
        this.handler = callback;
        this.time = time;
        this.interval = null;

        if( scope ) {
            this.handler = callback.bind( scope )
        }

        return this;
    }

    start() {
        this.interval = setInterval(this.handler, this.time * 1000);
        return this;
    }

    stop() {
        clearInterval( this.interval );
        return this;
    }

    reset() {
        this.stop();
        this.start();
        return this;
    }

}